import React, { useState, useEffect } from 'react';
import { Form } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { addPrescription, getPrescription, upatePrescription, upatePrescriptionStatus, addclubfittingdata } from "../../Api/prescriptionApis";
import Spinner from 'react-bootstrap/Spinner';
import { getCurrentUser } from "../../Api/auth";
import Modal from 'react-bootstrap/Modal';
import { FaStar } from "react-icons/fa";
import { useHistory } from 'react-router-dom';
import { FaCheck, FaHeart } from "react-icons/fa";
import './LeftScript2.css'
import { getInventoryByType } from "../../Api/inventoryApi";

import { getModeldatabymake } from "../../Api/inventoryApi";

export const API_URL = process.env.REACT_APP_API_URL;

const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',

    bounceselect: '',
    lieageselect: '',
    shaftweightselect: '',
    shaftflexselect: '',
    shaftprofileselect: '',
    gripSizeselect: '',
    clubLengthselect: '',
    swingWeightselect: '',

    bouncedropdownselect: '',
    lieagedropdownselect: '',
    shaftweightdropdownselect: '',
    shaftflexdropdownselect: '',
    shaftprofiledropdownselect: '',
    gripSizedropdownselect: '',
    clubLengthdropdownselect: '',
    swingWeightdropdownselect: '',
};


function LeftScript3({ project_id, prescriptionid, allMakeData, remortFittingFormData }) {


    const [head1, setHead1] = useState('');
    const [head2, setHead2] = useState('');
    const [head3, setHead3] = useState('');

    const [Shaft1, setShaft1] = useState('');
    const [Shaft2, setShaft2] = useState('');
    const [Shaft3, setShaft3] = useState('');

    const [Grip1, setGrip1] = useState('');
    const [Grip2, setGrip2] = useState('');
    const [Grip3, setGrip3] = useState('');
    const [remortFittingimages, setRemortFittingImages] = useState([]);

    const [heartdata, setHeartdata] = useState({});

  

    const history = useHistory();

    const [show03, setShow03] = useState(false);

    const handleClose03 = () => setShow03(false);
    const handleShow03 = () => setShow03(true);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleChange = (field, value) => {
        setPrescription(prevState => ({
            ...prevState,
            [field]: value
        }));
    };

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);

    const handleNestedChange = (section, option, subField, value) => {


        var type_id = "";
        if (section === "optimalHeads") {
            type_id = "4";
        }

        if (section === "optimalShafts") {
            type_id = "7";
        }

        if (section === "optimalGrips") {
            type_id = "8";
        }

        const data = {
            make_id: value,
            type_id: type_id
        }
        getModeldatabymake(data).then((response) => {
            console.log("aminesh", 18);
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                if (section === 'optimalHeads' && subField === 'make' && option === 1) {
                    setHead1(data);
                }
                if (section === 'optimalHeads' && subField === 'make' && option === 2) {
                    setHead2(data);
                }
                if (section === 'optimalHeads' && subField === 'make' && option === 3) {
                    setHead3(data);
                }

                if (section === 'optimalShafts' && subField === 'make' && option === 1) {
                    setShaft1(data);
                }
                if (section === 'optimalShafts' && subField === 'make' && option === 2) {
                    setShaft2(data);
                }
                if (section === 'optimalShafts' && subField === 'make' && option === 3) {
                    setShaft3(data);
                }

                if (section === 'optimalGrips' && subField === 'make' && option === 1) {
                    setGrip1(data);
                }
                if (section === 'optimalGrips' && subField === 'make' && option === 2) {
                    setGrip2(data);
                }
                if (section === 'optimalGrips' && subField === 'make' && option === 3) {
                    setGrip3(data);
                }
            }
        }).catch((err) => {
            alert(err);
        })




        setPrescription(prevState => ({
            ...prevState,
            [section]: {
                ...prevState[section],
                [`option${option}`]: {
                    ...(prevState[section] && prevState[section][`option${option}`]),
                    [subField]: value
                }
            }
        }));
    };

    const handlesaveproject = (event) => {

        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            // event.preventDefault();
            event.stopPropagation();
            handleShow();
        }

        else {
            setApicall(true);
            const data = {
                'prescription': JSON.stringify(prescription),
                'project_id': project_id,
                'user_id': userdata._id,
            }
            addclubfittingdata(data).then((res) => {
                // console.log("res", res);
                if (!res.data.status) {
                    setErrors(res.data.data);
                    alert(res.data.data[0].detail);
                } else {
                    setApicall(false);
                    //getprojectdata();
                    handleShow03();
                    window.scrollTo(0, 0);
                    window.location.reload();
                    // const timer = setTimeout(() => {
                    //     history.push('/project/prescription/prescription-view/' + project_id);  // Change this to the path you want to redirect to
                    // }, 2000);
                }

            }).catch((error) => {
                console.log("error", error);
            });
        }

        setValidated(true);
    }


    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState([]);
    const [userdata, setUserdata] = useState('');

    const [prescription, setPrescription] = useState(initialPrescriptionState);
    const [fittingid, setfittingid] = useState('');
    const [apicall, setApicall] = useState(false);


    const [makedata, setMakeData] = useState([]);
    const [shaftdata, setShaftData] = useState([]);
    const [gripdata, setGripData] = useState([]);

    const getmakedata = (id) => {
        const data = {
            type_id: id
        }
        const filtermakedata = allMakeData && allMakeData.filter((item) => item.item_type_id.includes(id));
        if (id === 4) {
            setMakeData(filtermakedata);
        }
        if (id === 7) {
            setShaftData(filtermakedata);
        }
        if (id === 8) {
            setGripData(filtermakedata);
        }
    }



    useEffect(() => {
        getmakedata(4);
        getmakedata(7);
        getmakedata(8);
    }, []);

    const handleRadioChange = (field, value) => {
        // setPrescription((prevState) => ({
        //     ...prevState,
        //     [field]: value,
        // }));
    };

    const handleSelectChange = (field, value) => {
        setPrescription((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };


    useEffect(() => {

        if (remortFittingFormData) {
            setRemortFittingImages(remortFittingFormData?.remotefittingimage?.remotefittingimage);
            setPrescription(remortFittingFormData?.fittingdata);
            setfittingid(remortFittingFormData?._id)


            const remotefittingdata = remortFittingFormData?.remotefittingdata || {};
            const transformedData = Object.keys(remotefittingdata)
                .filter(key => key !== "step0") // Exclude step0 or any other undesired steps
                .reduce((acc, key) => {
                    acc[key] = { preferred_club: remotefittingdata[key].preferred_club };
                    return acc;
                }, {});

            setHeartdata(transformedData);
        }

    }, [remortFittingFormData])



    return (

        <>
            <Modal
                show={show03}
                // onHide={handleClose03}
                onHide={() => {
                    handleClose03();
                    window.scrollTo(0, 0);
                }}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <h2 className="text-center mb-3">
                        Success!
                    </h2>
                    <p className="text-center mb-4">
                        Your data added successfully.
                    </p>

                    <button type="button" className="btn btn-modal-view" onClick={handleClose03}>
                        OK, got it!
                    </button>
                </Modal.Body>
            </Modal>

            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <h2 className="text-center mb-3">
                        You missed something!
                    </h2>
                    <p className="text-center mb-4">
                        Please fill out every input field in this section before moving on to the next section.
                    </p>

                    <button type="button" className="btn btn-modal-view" onClick={handleClose}>
                        OK, got it!
                    </button>
                </Modal.Body>
            </Modal>
            
            <div className="col-lg-8 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2 dashboard_2 study_guide_open db_col">
                <Form noValidate validated={validated} onSubmit={handlesaveproject}>
                    <div className="listing-box">
                        <div className="black_bg_box" style={{ border: '4px solid #ffffff' }}>
                            <div className="club-fitting-card">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>White</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.bounce && prescription?.bouncedropdownselect  ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="form-group prescription-note">

                                <div className="row mb-4">

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("bounceselect", "1")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing0} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step1?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("bounceselect", "2")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing1} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step1?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("bounceselect", "3")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing2} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step1?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="row gx-2">
                                    <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                        <h3 style={{ color: "#ffffff" }}>Bounce</h3>
                                    </div>
                                    <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                            value={prescription?.bouncedropdownselect}
                                            onChange={(e) => handleSelectChange('bouncedropdownselect', e.target.value)}>
                                            <option value={0}>Select Bounce</option>
                                            <option value="1">Low Bounce</option>
                                            <option value="2">Mid Bounce</option>
                                            <option value="3">High Bounce</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                                <textarea className="dashboard-text-area" value={prescription?.bounce} onChange={(e) => handleChange('bounce', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add your bounce notes..." required></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid bounce.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box" style={{ border: '4px solid #000000' }}>
                            <div className="club-fitting-card black_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Black</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.lieage && prescription?.lieagedropdownselect  ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <div className="row mb-4">
                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("lieageselect", "1")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing3} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step2?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("lieageselect", "2")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing4} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step2?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("lieageselect", "3")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing5} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step2?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-2">
                                    <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                        <h3 style={{ color: "#ffffff" }}>Lie Angle</h3>
                                    </div>
                                    <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                            value={prescription?.lieagedropdownselect}
                                            onChange={(e) => handleSelectChange('lieagedropdownselect', e.target.value)}>
                                            <option value={0}>Select Lie Angle</option>
                                            <option value="1">Upright</option>
                                            <option value="2">Standard</option>
                                            <option value="3">Flat</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>

                                </div>
                                <textarea className="dashboard-text-area" value={prescription?.lieage} onChange={(e) => handleChange('lieage', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add lie angle notes..." required></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid lie angle.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box" style={{ border: '4px solid #033df8' }}>
                            <div className="club-fitting-card blue_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Blue</h5></div>
                                    <div className="collapsed"> 
                                        <div className={`head_check ${prescription && prescription?.shaftweight && prescription?.shaftweightdropdownselect   ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <div className="row mb-4">
                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("shaftweightselect", "1")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing6} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step3?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("shaftweightselect", "2")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing7} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step3?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("shaftweightselect", "3")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing9} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step3?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-2">
                                    <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                        <h3 style={{ color: "#ffffff" }}>Shaft Weight</h3>
                                    </div>
                                    <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                            value={prescription?.shaftweightdropdownselect}
                                            onChange={(e) => handleSelectChange('shaftweightdropdownselect', e.target.value)}>
                                            <option value={0}>Select Shaft Weight</option>
                                            <option value="1">Heavy</option>
                                            <option value="2">Medium</option>
                                            <option value="3">Light</option>
                                        </select>
                                    </div>

                                </div>
                                <textarea className="dashboard-text-area" value={prescription?.shaftweight} onChange={(e) => handleChange('shaftweight', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add shaft weight notes..." required></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid shaft weight.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box" style={{ border: '4px solid #f73aec' }}>
                            <div className="club-fitting-card pink_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Pink</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.shaftflex && prescription?.shaftflexdropdownselect   ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <div className="row mb-4">
                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("shaftflexselect", "1")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing9} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step4?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("shaftflexselect", "2")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing10} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step4?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("shaftflexselect", "3")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing11} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step4?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-2">
                                    <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                        <h3 style={{ color: "#ffffff" }}>Shaft Flex</h3>
                                    </div>
                                    <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                            value={prescription?.shaftflexdropdownselect}
                                            onChange={(e) => handleSelectChange('shaftflexdropdownselect', e.target.value)}>
                                            <option value={0}>Select Shaft Flex</option>
                                            <option value="1">Hard</option>
                                            <option value="2">Medium</option>
                                            <option value="3">Soft</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Shaft Flex
                                        </Form.Control.Feedback>
                                    </div>

                                </div>
                                <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" value={prescription?.shaftflex} onChange={(e) => handleChange('shaftflex', e.target.value)} rows="10" placeholder="Add shaft flex notes..." required></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid shaft flex.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box" style={{ border: '4px solid #9d02d6' }}>
                            <div className="club-fitting-card purple_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Purple</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.shaftprofile && prescription?.shaftprofiledropdownselect   ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <div className="row mb-4">
                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        // onClick={() => handleRadioChange("shaftprofileselect", "1")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing12} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step5?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        onClick={() => handleRadioChange("shaftprofileselect", "2")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing13} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step5?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        onClick={() => handleRadioChange("shaftprofileselect", "3")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing14} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step5?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-2">
                                    <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                        <h3 style={{ color: "#ffffff" }}>Shaft Profile</h3>
                                    </div>
                                    <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                            value={prescription?.shaftprofiledropdownselect}
                                            onChange={(e) => handleSelectChange('shaftprofiledropdownselect', e.target.value)}>
                                            <option value={0}>Select Shaft Profile</option>
                                            <option value="1">Firm Tip</option>
                                            <option value="2">Soft Mid</option>
                                            <option value="3">Firm Butt</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>

                                </div>
                                <textarea className="dashboard-text-area" value={prescription?.shaftprofile} onChange={(e) => handleChange('shaftprofile', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add shaft profile notes..." required></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid shaft profile.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box" style={{ border: '4px solid #f1030e' }}>
                            <div className="club-fitting-card red_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Red</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.gripSize && prescription?.gripSizedropdownselect   ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <div className="row mb-4">
                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        onClick={() => handleRadioChange("gripSizeselect", "1")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing15} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step6?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        onClick={() => handleRadioChange("gripSizeselect", "2")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing16} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step6?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        onClick={() => handleRadioChange("gripSizeselect", "3")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing17} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step6?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-2">
                                    <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                        <h3 style={{ color: "#ffffff" }}>Grip Size</h3>
                                    </div>
                                    <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                            value={prescription?.gripSizedropdownselect}
                                            onChange={(e) => handleSelectChange('gripSizedropdownselect', e.target.value)}>
                                            <option value={0}>Select Grip Size</option>
                                            <option value="1">Oversize</option>
                                            <option value="2">Mid</option>
                                            <option value="3">Standard</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>

                                </div>
                                <textarea className="dashboard-text-area" value={prescription?.gripSize} onChange={(e) => handleChange('gripSize', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add grip size notes..." required></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid grip size.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box" style={{ border: '4px solid #e58700' }}>
                            <div className="club-fitting-card orange_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Orange</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.clubLength && prescription?.clubLengthdropdownselect  ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <div className="row mb-4">
                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        onClick={() => handleRadioChange("clubLengthselect", "1")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing18} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step7?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        onClick={() => handleRadioChange("clubLengthselect", "2")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing19} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step7?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        onClick={() => handleRadioChange("clubLengthselect", "3")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing20} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step7?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-2">
                                    <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                        <h3 style={{ color: "#ffffff" }}>Club Length</h3>
                                    </div>
                                    <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                            value={prescription?.clubLengthdropdownselect}
                                            onChange={(e) => handleSelectChange('clubLengthdropdownselect', e.target.value)}>
                                            <option value={0}>Select Club Length</option>
                                            <option value="1">Long</option>
                                            <option value="2">Medium</option>
                                            <option value="3">Short</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>

                                </div>
                                <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" value={prescription?.clubLength} onChange={(e) => handleChange('clubLength', e.target.value)} rows="10" placeholder="Add club length notes..." required></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid club length.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        <div className="black_bg_box" style={{ border: '4px solid #82bf2a' }}>
                            <div className="club-fitting-card green_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Green</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.swingWeight && prescription?.swingWeightdropdownselect   ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                <div className="row mb-4">
                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        onClick={() => handleRadioChange("swingWeightselect", "1")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing21} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step8?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        onClick={() => handleRadioChange("swingWeightselect", "2")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing22} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step8?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>

                                    <div
                                        className="col-12 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                                        style={{ position: 'relative' }}
                                        onClick={() => handleRadioChange("swingWeightselect", "3")}
                                    >
                                        <div style={{ maxHeight: '100%', maxWidth: '100%', overflow: 'hidden', borderRadius: '10%', position: 'relative' }}>
                                            <img src={API_URL + "remotefittingimage/" + remortFittingimages?.swing23} alt="img"
                                                style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                            <FaHeart
                                                color={heartdata?.step8?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                className='heart-icon'
                                                style={{ position: 'absolute', bottom: '15px', right: '15px', zIndex: 1 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-2">
                                    <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                        <h3 style={{ color: "#ffffff" }}>Swing Weight</h3>
                                    </div>
                                    <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                        <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                            value={prescription?.swingWeightdropdownselect}
                                            onChange={(e) => handleSelectChange('swingWeightdropdownselect', e.target.value)}>
                                            <option value={0}>Select Swing Weight</option>
                                            <option value="1">Heavy</option>
                                            <option value="2">Medium</option>
                                            <option value="3">Light</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>

                                </div>
                                <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" value={prescription?.swingWeight} onChange={(e) => handleChange('swingWeight', e.target.value)} rows="10" placeholder="Add swing weight notes..." required></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid swing weight.
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>
                    <div className="btn-box-section btn-inline-box">
                        <button className="btn btn-primary btn-remove">Remove Project</button>

                        <>
                            {
                                fittingid === null || fittingid === undefined || fittingid === ""
                                    ? (
                                        <button className="btn btn-primary btn-create" type='submit'>
                                            {apicall ? (<Spinner animation="border" className="border-black" />) : (<span>Save Project</span>)}
                                        </button>
                                    )
                                    : (
                                        <button className="btn btn-primary btn-create" type='submit'>
                                            {apicall ? (<Spinner animation="border" className="border-black" />) : (<span>Update Project</span>)}
                                        </button>
                                    )
                            }
                        </>

                    </div>
                </Form>
            </div>
        </>


    );

}

export default LeftScript3;